import { useEffect } from 'react';

function isMobileDevice(): boolean {
  const mobileUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
      navigator.userAgent
    );
  const isNarrowTouchViewport = window.matchMedia(
    '(max-width: 768px) and (pointer: coarse)'
  ).matches;

  return mobileUserAgent || isNarrowTouchViewport;
}

/**
 * Mobile browsers (especially iOS Safari) auto-zoom when focusing inputs with
 * font-size < 16px and can keep that zoom level after SPA navigation.
 * Reset the viewport scale on mount.
 */
export function useResetIosZoom() {
  useEffect(() => {
    if (!isMobileDevice()) return;

    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    const originalContent = viewport.getAttribute('content') ?? '';
    viewport.setAttribute(
      'content',
      `${originalContent}, maximum-scale=1.0, user-scalable=no`
    );

    const timeoutId = window.setTimeout(() => {
      viewport.setAttribute('content', originalContent);
    }, 150);

    return () => window.clearTimeout(timeoutId);
  }, []);
}
